import React from 'react';
import { AuthContext } from './useAuth';

// 自定义 Hook 使用认证上下文
export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};